import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { Nav } from "./Nav";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { EventsSection } from "./EventsSection";
import { ExperienceSection } from "./ExperienceSection";
import { VisitSection } from "./VisitSection";
import { FaqSection } from "./FaqSection";
import { CoverModal } from "./CoverModal";
import { eventISO, logClick, parsePrice, trackEvent } from "@/lib/site";

export default function PublicSite({ events, eventsLoaded }) {
  const [selectedEvent, setSelectedEvent] = useState(null);
  useEffect(() => {
    if (!sessionStorage.getItem("soho_visit")) {
      sessionStorage.setItem("soho_visit", "1");
      logClick("visit");
    }
  }, []);

  useEffect(() => {
    if (!eventsLoaded || !events.length) return undefined;
    const schema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: events.map((event, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Event",
          name: `${event.title} at Soho Goa`,
          startDate: eventISO(event) || undefined,
          eventStatus: "https://schema.org/EventScheduled",
          location: { "@type": "Place", name: "Soho Goa - Nightclub", address: "Calangute - Baga Rd, Baga, Arpora, Goa 403516" },
          image: event.image,
          url: "https://sohogoa.com/#events",
          offers: { "@type": "Offer", price: parsePrice(event.price_female) || parsePrice(event.price), priceCurrency: "INR", availability: "https://schema.org/InStock" },
        },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "events-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById("events-schema")?.remove(); };
  }, [events, eventsLoaded]);

  return (
    <div className="site-shell">
      <Nav />
      <main id="top">
        <Hero />
        <Marquee />
        <EventsSection events={events} onBuy={(event) => { trackEvent("cover_charge_click", { event_name: event.title }); logClick("cover_click", event.title); setSelectedEvent(event); }} />
        <ExperienceSection />
        <VisitSection />
        <FaqSection />
      </main>
      <footer>
        <div className="footer-top">
          <a className="brand" href="#top" data-testid="footer-brand"><img src="/logo.jpg" className="brand-logo" alt="Soho Goa"/></a>
          <span>© 2026 Soho Goa. Stay out late.</span>
          <div><a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="instagram-link"><Instagram size={18}/></a><span>All rights reserved.</span></div>
        </div>
        <p className="footer-seo">Soho Goa — Bollywood nightclub in Baga, on Calangute–Baga Road near Tito’s Lane, North Goa. Bollywood nights, commercial parties and sundowners. Open 9 PM till late, all week.</p>
        <div className="footer-links">
          <span>Explore Soho Goa</span>
          <a href="/bollywood-nights-goa">Bollywood nights in Goa</a>
          <a href="/clubs-in-baga">Best clubs in Baga guide</a>
          <a href="/ladies-night-goa">Ladies night in Goa</a>
          <a href="/vip-table-booking-goa">VIP table booking</a>
        </div>
        <div className="footer-mark" aria-hidden="true">SOHO</div>
      </footer>
      <CoverModal event={selectedEvent} onClose={() => setSelectedEvent(null)} />
    </div>
  );
}
